import styled, { css } from 'styled-components';
import { font, themes } from '@chegg-ui/theme';
var base = css(["text-align:center;color:black;"]);
export var H4 = styled.h4.withConfig({
  componentId: "sc-1mj9o00-0"
})(["", ";font-size:", ";margin:0;line-height:", ";font-weight:", ";letter-spacing:0;"], base, font.size.px32, themes.horizon.font.lineHeight.sm, font.weight.heavy);
export var H3 = styled.h3.withConfig({
  componentId: "sc-1mj9o00-1"
})(["font-size:", ";font-weight:normal;margin:0;", ";"], font.size.px18, base);